module.exports = __webpack_public_path__ + "img/plus.89eda948.svg";